














































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ITreeData, IPpr, IMonthVal, IMonthTotal, ISelected } from "./treeTableData";
import CPopUp from "../CPopUp.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import NumpadEnterMixin from "@/modules/budget/alteration/mixins/numpad-enter-mixin";
import CTransfAddItemModal
    from "@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/CTransfAddItemModal.vue";
import {log} from "@amcharts/amcharts4/.internal/core/utils/Log";
import CReasonCell from "@/modules/budget/alteration/form/tabs/components/CreateForm/reasons/CReasonCell.vue";
import {
    IReasonGroup,
    IReasonTarget,
    ReasonPlanType,
    reasonKey
} from "@/modules/budget/alteration/form/tabs/components/CreateForm/reasons/alteration-reason-api";

const monthLst = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

@Component({
    name: 'c-prg-tree-table',
    components: { 'c-pop-up': CPopUp,
        'c-transf-add-modal': CTransfAddItemModal,
        'c-reason-cell': CReasonCell },
    computed: {
        locale() {
            return this.$i18n.locale;
        }
    }
})
export default class CPrgTreeTable extends mixins(AlterationI18nMixin, NumpadEnterMixin) {
    @Prop({
        required: true,
        default: null
    })
    private tableData!: any;

    @Prop({
        required: true,
        default: []
    })
    private editedMonths!: number[]; // 0-11

    @Prop({
        required: true,
        default: []
    })
    private createdMonths!: number; // 0-11

    @Prop({
        required: true,
        default: null
    })
    private accessLevel!: any;

    @Prop({
        required: true,
        default: null
    })
    private uSumVisible!: number;

    @Prop({
        required: true,
        default: ''
    })
    private flc2!: any;

    @Prop({
        required: true,
        default: ''
    })
    private flc4!: any;

    // --- Колонка "Примечание" (причина отклонения), только для заявки АБП без ГУ (EAK-1557) ---
    @Prop({
        required: false,
        default: false
    })
    private reasonVisible!: boolean;

    @Prop({
        required: false,
        default: false
    })
    private reasonEditable!: boolean;

    @Prop({
        required: false,
        default: () => ({})
    })
    private reasonGroups!: Record<string, IReasonGroup>;

    @Prop({
        required: false,
        default: 1
    })
    private reasonPlanType!: ReasonPlanType;

    private collapseAll = true;

    private selectedRow: ISelected | null = null;

    private treeData: ITreeData[] = [];

    private totalSum: IMonthTotal = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, utochSum: 0, sum: 0, ost: 0, ostDate: '' };

    private showAddItemModal = false;
    private transfertData: any[] = [];
    private itemsEl: {} = {};
    private settingsData: any[] = [];
    private showAddItemButton = false;
    private showAddButton = false;
    private componentId = Math.random().toString(36).substr(2, 9);
    private mounted() {
        this.getTreeData();
    }
    private created() {
        this.loadSettingsTr();
        this.$watch('tableData', () => {
            this.getTreeData();
        }, { deep: true });

        this.$watch('locale', () => {
            this.getTreeData();
        }, { deep: true });
    }
    private get editedArr() {
        const editedArr = [false, false, false, false, false, false, false, false, false, false, false, false];
        this.showAddButton = false;
        if (!this.accessLevel.editAccess) { return editedArr; }
        for (const el of this.editedMonths) {
            this.showAddButton = true;
            editedArr[el] = true;
        }
        return editedArr;
    }
    /**
     * Возвращает сумму плановых значений с января по указанный месяц (индекс 0-11)
     * @param el Объект данных (строка таблицы)
     * @param monthIdx Индекс месяца, по который нужно считать сумму (0 - январь, 11 - декабрь)
     */
    private getPlanSumUpToMonth(el: any, monthIdx: number): number {
        let sum = 0;
        // Ограничиваем цикл индексом выбранного месяца
        for (let i = 0; i <= monthIdx; i++) {
            const monthName = monthLst[i];
            const val = el[monthName];
            if (val) {
                sum += (typeof val === 'number' ? val : parseFloat(val) || 0);
            }
        }
        // Округляем до одного знака после запятой, как это сделано в других методах компонента
        return Math.round(sum * 10) / 10;
    }
    private monthSum(el: any, month: number) {
        let sum = 0;
        for (let i = month; i > -1; i--) {
            sum = parseFloat((Math.round((sum + el['month' + i])* 10) / 10).toFixed(1));
        }
        return sum;
    }
    private flcCheck(arr: any[], el: any){
        let ch = false;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].id === el.id) {
                ch = true;
            }
        }
        if (!ch) {
            arr.push(el);
        }
    }
    private getFlk4(el: any) { // проверка флк
        for (let i = this.createdMonths; i < 12; i++) {
            const fieldName = `month${i}`;
            const currentVal = (i === this.createdMonths ? this.monthSum(el, i) : el[fieldName]) || 0;
            const planVal = (i === this.createdMonths ? this.getPlanSumUpToMonth(el, i) : el[monthLst[i]]) || 0;
            if (currentVal < 0 && (currentVal + planVal < 0)) {
                if (!el.flk) { Vue.set(el, 'flk', {}); }
                if (!el.flk[fieldName]) { Vue.set(el.flk, fieldName, []); }

                this.flcCheck(el.flk[fieldName], { id: 4, typeErr: this.flc4, textErr: this.setText('flc.flc4') });
                this.$emit('agrBtn', this.flc4.length > 0);
                this.$emit('flcControls', { id: 4, typeErr: this.flc4, textErr: this.setText('flc.flc4txt') });
            } else {
                // Если условие ФЛК4 больше не нарушается, удаляем ошибку из списка
                if (el.flk && el.flk[fieldName]) {
                    const index = el.flk[fieldName].findIndex((item: any) => item.id === 4);
                    if (index !== -1) {
                        el.flk[fieldName].splice(index, 1);
                    }
                }
            }
        }
    }
    private getFlk2(el: any) { // проверка флк
        if (el[`month${this.createdMonths}`] < 0) {
            if (Math.abs(el[`month${this.createdMonths}`]) > el[`ost`]) {
                if (!el.flk) { el.flk = {}; }
                if (!el.flk[`month${this.createdMonths}`]) { el.flk[`month${this.createdMonths}`] = []; }
                let sum = 0;
                for (let i=0; i < this.createdMonths+1; i++) {
                    sum = sum + el[`month${i}`]
                }
                const sums = parseFloat(String(Math.abs(sum) - el[`ost`]));
                // el.flk[`month${this.createdMonths}`].push({typeErr: this.flc2, textErr: this.setText('flc.flc2') + ((sums).toFixed(2)).toString() + this.setText('1000tg')});
                this.flcCheck(el.flk[`month${this.createdMonths}`], { id: 2, typeErr: this.flc2, textErr: this.setText('flc.flc2') + ((sums).toFixed(3)).toString() + this.setText('1000tg') });
                this.$emit('agrBtn', this.flc2.length > 0);
                this.$emit('flcControls', { id: 2, typeErr: this.flc2, textErr: this.setText('flc.flc2txt') });
            }
        }
    }
    private getTreeData() {
        const prgStates: Record<string, boolean> = {};
        const pprStates: Record<string, boolean> = {};
        const spfStates: Record<string, boolean> = {};

        this.treeData.forEach(prg => {
            prgStates[prg.prg] = prg.collapse;
            prg.vals.forEach(ppr => {
                pprStates[`${prg.prg}_${ppr.ppr}`] = ppr.collapse;
                ppr.vals.forEach(spf => {
                    if (spf.collapse !== undefined) {
                        spfStates[`${prg.prg}_${ppr.ppr}_${spf.spf}`] = spf.collapse;
                    }
                });
            });
        });

        const treeData: ITreeData[] = [];
        this.totalSum = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, utochSum: 0, sum: 0, ost: 0, ostDate: '' };

        if (!this.tableData) {
            this.treeData = [];
            return;
        }

        const tableData = JSON.parse(JSON.stringify(this.tableData));
        this.nameSet(tableData);

        // 1. Группировка по программам
        const mapPrg = new Map();
        for (let i = 0; i < tableData.length; i++) {
            const el = tableData[i];
            el.ost = el.ost || 0;
            el._indxArr = i;
            let prgObj = mapPrg.get(el.prg);
            if (!prgObj) {
                prgObj = { prg: el.prg, prgName: el.prg_name, vals: [el] };
            } else {
                prgObj.vals.push(el);
            }
            mapPrg.set(el.prg, prgObj);
        }

        // 2. Группировка по подпрограммам
        for (const [keyPrg, valPrg] of mapPrg) {
            const mapPpr = new Map();
            for (const elPpr of valPrg.vals) {
                let pprObj = mapPpr.get(elPpr.ppr);
                if (!pprObj) {
                    pprObj = { ppr: elPpr.ppr, pprName: elPpr.ppr_name, vals: [elPpr] };
                } else {
                    pprObj.vals.push(elPpr);
                }
                mapPpr.set(elPpr.ppr, pprObj);
            }
            mapPrg.set(keyPrg, { ...valPrg, vals: mapPpr });
        }

        const totalSumTemplate: IMonthTotal = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, utochSum: 0, ost: 0, ostDate: '' };

        for (const [keyPrg, valPrg] of mapPrg) {
            const objPrg: ITreeData = {
                prg: valPrg.prg,
                prgName: valPrg.prgName,
                vals: [],
                totalSum: Object.assign({}, totalSumTemplate),
                utochSum: 0,
                collapse: prgStates[valPrg.prg] !== undefined ? prgStates[valPrg.prg] : this.collapseAll
            };

            for (const [keySub, valSub] of valPrg.vals) {
                const objSub: IPpr = {
                    ppr: valSub.ppr,
                    pprName: valSub.pprName,
                    vals: [],
                    totalSum: Object.assign({}, totalSumTemplate),
                    utochSum: 0,
                    collapse: pprStates[`${valPrg.prg}_${valSub.ppr}`] !== undefined ? pprStates[`${valPrg.prg}_${valSub.ppr}`] : this.collapseAll
                };

                // 3. Объединение одинаковых специфик (SPF) внутри подпрограммы
                const spfMap = new Map();
                for (const spfEl of valSub.vals) {
                    if (!spfMap.has(spfEl.spf)) {
                        spfMap.set(spfEl.spf, spfEl);
                    } else {
                        const existingSpf = spfMap.get(spfEl.spf);
                        // Складываем запрашиваемые суммы
                        this.getSumTotal(existingSpf, spfEl);

                        // Складываем плановые значения (для корректной проверки ФЛК4)
                        for (const monthName of monthLst) {
                            existingSpf[monthName] = Math.round(((existingSpf[monthName] || 0) + (spfEl[monthName] || 0)) * 10) / 10;
                        }

                        // Слияние child_list (одинаковых расходов)
                        if (spfEl.child_list && spfEl.child_list.length) {
                            if (!existingSpf.child_list) { existingSpf.child_list = []; }
                            for (const childEl of spfEl.child_list) {
                                const existingChild = existingSpf.child_list.find((c: any) => c.expense_code === childEl.expense_code);
                                if (existingChild) {
                                    this.getSumTotal(existingChild, childEl);

                                    // Складываем плановые значения проекта (по аналогии со спецификами, стр. выше) -
                                    // нужно для корректной проверки ФЛК4 по проекту
                                    for (const monthName of monthLst) {
                                        existingChild[monthName] = Math.round(((existingChild[monthName] || 0) + (childEl[monthName] || 0)) * 10) / 10;
                                    }
                                } else {
                                    existingSpf.child_list.push(childEl);
                                }
                            }
                        }
                    }
                }

                // 4. Формирование итогового списка специфик для подпрограммы
                for (const spfEl of spfMap.values()) {
                    // Выполняем проверки ФЛК на объединенных данных
                    this.getFlk4(spfEl);
                    this.getFlk2(spfEl);
                    // Проверка проектов (дочерних элементов)
                    if (spfEl.child_list && Array.isArray(spfEl.child_list)) {
                        spfEl.child_list.forEach((child: any) => {
                            this.getFlk4(child);
                        });
                    }

                    spfEl.parentSpf = true;
                    if (spfEl.child_list && spfEl.child_list.length) {
                        const storedSpfCollapse = spfStates[`${valPrg.prg}_${valSub.ppr}_${spfEl.spf}`];
                        spfEl.collapse = storedSpfCollapse !== undefined ? storedSpfCollapse : this.collapseAll;
                        spfEl.parentSpf = false;
                    }
                    this.getSumTotal(objSub.totalSum, spfEl);
                    objSub.vals.push(spfEl);
                }

                objSub.vals.sort((a, b) => (a.spf - b.spf > 0 ? 1 : -1));
                objPrg.vals.push(objSub);
                this.getSumTotal(objPrg.totalSum, objSub.totalSum);
            }
            objPrg.vals.sort((a, b) => (a.ppr - b.ppr > 0 ? 1 : -1));
            treeData.push(objPrg);
            this.getSumTotal(this.totalSum, objPrg.totalSum);
        }

        this.totalSum.sum = this.getSum(this.totalSum);
        treeData.sort((a, b) => (a.prg - b.prg > 0 ? 1 : -1));
        this.treeData = treeData;
        this.$emit('getTree', this.treeData);
    }
    private getSum(obj: any) {
        let sum = 0;
        for (let i=0; i < 12; i++) {
            if (obj[`month${i}`]) {
                sum = Math.round(((typeof obj[`month${i}`] == 'number' ? obj[`month${i}`] : parseFloat(obj[`month${i}`])) + sum)*10)/10;
            }
        }
        return sum;
    }
    private getSumTotal(total: any, obj: any) {
        // Суммируем помесячные значения
        for (let i = 0; i < 12; i++) {
            const field = `month${i}`;
            const val = obj[field];
            if (val !== undefined && val !== null) {
                const numVal = typeof val === 'number' ? val : parseFloat(val) || 0;
                total[field] = Math.round(((total[field] || 0) + numVal) * 10) / 10;
            }
        }
        // Суммируем уточненную сумму
        if (obj.utochSum) {
            const numUtoch = typeof obj.utochSum === 'number' ? obj.utochSum : parseFloat(obj.utochSum) || 0;
            total.utochSum = Math.round(((total.utochSum || 0) + numUtoch) * 10) / 10;
        }
        // Суммируем остатки
        if (obj.ost) {
            const numOst = typeof obj.ost === 'number' ? obj.ost : parseFloat(obj.ost) || 0;
            total.ost = (total.ost || 0) + numOst;
        }
        if (obj.ostDate) { total.ostDate = obj.ostDate; }
    }

    private clkCollapse(prgIndx: number | null, subIndx: number | null, spfIndx: number | null, collapse?: boolean) {
        if (prgIndx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.treeData) {
                el.collapse = this.collapseAll;
                for (const subEl of el.vals) {
                    subEl.collapse = this.collapseAll;
                    for (const spfEl of subEl.vals) {
                        if (spfEl.collapse!==undefined) { spfEl.collapse = this.collapseAll; }
                    }
                }
            }
            return;
        }

        if (collapse ===undefined) { return; }


        if (subIndx === null) {
            this.treeData[prgIndx].collapse = collapse;
            if (!collapse && this.collapseAll) { this.collapseAll = false; }
            if (collapse !== this.collapseAll) {
                let fl = false;
                for (let i =0; i < this.treeData.length; i++) {
                    if (this.treeData[i].collapse !== collapse) {
                        fl = true;
                        break;
                    }
                }
                if (!fl) { this.collapseAll = collapse; }
            }
            for (const subEl of this.treeData[prgIndx].vals) {
                subEl.collapse = collapse;
                for (const spfEl of subEl.vals) {
                    if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                }
            }
        } else {
            if (spfIndx === null) {
                this.treeData[prgIndx].vals[subIndx].collapse = collapse;
                for (const spfEl of this.treeData[prgIndx].vals[subIndx].vals) {
                    if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                }
            } else {
                if (this.treeData[prgIndx].vals[subIndx].vals[spfIndx].collapse!==undefined) { this.treeData[prgIndx].vals[subIndx].vals[spfIndx].collapse = collapse; }
            }
         }
    }

    private selectRow(prgIndx: number, subIndx: number, spfIndx: number, formIndx: number | null){
        if (this.selectedRow) {
            const obj = this.getSelectedObj(this.selectedRow.prgIndx, this.selectedRow.subIndx, this.selectedRow.spfIndx, this.selectedRow.formIndx);
            if (obj) {
                obj.selectedRow = null;
            }
            /* if (this.selectedRow.prgIndx === prgIndx && this.selectedRow.subIndx === subIndx && this.selectedRow.spfIndx === spfIndx && this.selectedRow.formIndx === formIndx) {
                this.selectedRow = null;
                obj.selectedRow = null;
                return;
            } */
        }
        const obj = this.getSelectedObj(prgIndx, subIndx, spfIndx, formIndx);
        obj.selectedRow = true;
        const selectedRow = Object.assign({ prgIndx: prgIndx, subIndx: subIndx, spfIndx: spfIndx, formIndx: formIndx }, obj);
        let sum = 0;
        for (const monthName of monthLst) {
            sum += this.sumMonth(selectedRow, monthName);
        }
        selectedRow.sumMonth = Math.round(sum * 10) / 10;

        this.calcSumSelectedAndSpf(selectedRow);

        this.selectedRow = selectedRow;
    }

    private calcSumSelectedAndSpf(selectedRow: any) { // расчёт суммы планового значения и специфики (например january и month0)
        let sumMonthTmp = selectedRow.sumMonth;
        for (let i=0; i < 12; i++) {
            const val = selectedRow[`month${i}`] || 0;
            if (i === this.createdMonths && val < 0) {
                let remainingAbs = val;

                // 1. Помесячно отнимаем от плановых значений от createdMonths до января (индекс 0)
                for (let m = this.createdMonths; m >= 0; m--) {
                    const planM = selectedRow[monthLst[m]] || 0;

                    if (planM > 0) {
                        remainingAbs = planM + remainingAbs;
                        if (remainingAbs >= 0) {
                            selectedRow[`${monthLst[m]}_tmp`] = remainingAbs;
                            break;
                        } else { selectedRow[`${monthLst[m]}_tmp`] = 0; }
                    }
                    else { selectedRow[`${monthLst[m]}_tmp`] = planM; }
                }

                // 2. Если плановых значений не хватило, остаток отнимаем от плана месяца createdMonths
                if (remainingAbs < 0) {
                    selectedRow[`${monthLst[i]}_tmp`] = remainingAbs;
                }

            }
            else {
                selectedRow[`${monthLst[i]}_tmp`] = Math.round((selectedRow[monthLst[i]] + selectedRow[`month${i}`]) * 10) / 10;
            }
            sumMonthTmp += selectedRow[`month${i}`];
        }
        selectedRow.sumMonthTmp = Math.round(sumMonthTmp * 10)/10;
    }

    private sumMonth(monthObj: any, fieldName: string) {
        if (!monthObj[fieldName]) { monthObj[fieldName] = 0; }
         return monthObj[fieldName];
    }

    private getSelectedObj(prgIndx: number, subIndx: number, spfIndx: number, formIndx: number | null) {
        if (formIndx !== null) {
            return this.treeData[prgIndx].vals[subIndx].vals[spfIndx].child_list[formIndx];
        }
        return this.treeData[prgIndx].vals[subIndx].vals[spfIndx];
    }

    private chgValue(spfObj: any, fieldName: string, chldIndx?: number) {
        let obj = spfObj;
        if (chldIndx !== undefined) { obj = spfObj.child_list[chldIndx]; }
        if (parseFloat(String(obj[fieldName])).isNaN) { obj[fieldName] = 0; }
        obj[fieldName] = parseInt((obj[fieldName] * 10).toString()) / 10;
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        if (chldIndx !== undefined) {
            tableData[spfObj._indxArr].child_list[chldIndx][fieldName] = obj[fieldName];
            let chldSum = 0;
            for (const el of tableData[spfObj._indxArr].child_list) {
                chldSum = Math.round((chldSum + el[fieldName]) * 10) / 10;
            }
            tableData[spfObj._indxArr][fieldName] = chldSum

        } else {
            tableData[spfObj._indxArr][fieldName] = obj[fieldName];
        }
        // --- проверка чтобы сумма дочерних не была больше суммы родителя
        /*if (tableData[spfObj._indxArr].child_list) {
            let chldSum = 0;
            for (const el of tableData[spfObj._indxArr].child_list) {
                chldSum += el[fieldName];
            }
            if (tableData[spfObj._indxArr][fieldName]<chldSum) { tableData[spfObj._indxArr][fieldName] = chldSum; }
        }*/
        // --
        this.$emit('chgData', { tableData: tableData, indx: spfObj._indxArr, chldIndx: chldIndx, fieldName: fieldName });
        // obj[fieldName] = Math.round(parseFloat(String(obj[fieldName])) * 100) / 100;
    }

    // ------
    /**
     * Обработка Enter в графе месяца.
     * Enter на цифровом блоке (Numpad) — переход к следующему месяцу той же строки (как по Tab),
     * обычный Enter — прежнее поведение: та же графа месяца следующей строки.
     */
    private onEnterKey(event: KeyboardEvent, monthIndx: number, prgIndx: number, subIndx: number, spfIndx: number, chldIndx: number | null = null) {
        if (this.isNumpadEnter(event)) {
            this.nextMonthInput(monthIndx, prgIndx, subIndx, spfIndx, chldIndx);
            return;
        }
        this.nextInput(monthIndx, prgIndx, subIndx, spfIndx, chldIndx);
    }

    /**
     * Переход к следующему редактируемому месяцу текущей строки.
     * С последнего доступного месяца, как и по Tab, уходим на первый месяц следующей строки.
     */
    private async nextMonthInput(monthIndx: number, prgIndx: number, subIndx: number, spfIndx: number, chldIndx: number | null) {
        const editedArr = this.editedArr;
        const nextMonth = this.nextEditedMonth(monthIndx, editedArr);
        if (nextMonth === null) {
            const firstMonth = this.firstEditedMonth(editedArr);
            if (firstMonth === null) { return; }
            await this.nextInput(firstMonth, prgIndx, subIndx, spfIndx, chldIndx);
            return;
        }
        const name = chldIndx === null
            ? `inp_${prgIndx}_${subIndx}_${spfIndx}_month${nextMonth}`
            : `inp_${prgIndx}_${subIndx}_${spfIndx}_${chldIndx}_month${nextMonth}`;
        await this.selectInputByRef(name);
    }

    private async nextInput(monthIndx: number, prgIndx: number, subIndx: number, spfIndx: number, chldIndx: number | null = null) {
        let indxObj: any = { prgIndx, subIndx, spfIndx, chldIndx };
        if (chldIndx === null) {
            indxObj = this.getNextInputIndx(prgIndx, subIndx, spfIndx, chldIndx);
        } else {
            // @ts-ignore
            if (this.treeData[prgIndx].vals[subIndx].vals[spfIndx].child_list.length - 1 > chldIndx) {
                if (indxObj.chldIndx!==null) { indxObj.chldIndx++; }
            } else {
                indxObj = this.getNextInputIndx(prgIndx, subIndx, spfIndx, chldIndx);
            }
        }

        let name = '';
        this.treeData[indxObj.prgIndx].collapse = false;
        this.treeData[indxObj.prgIndx].vals[indxObj.subIndx].collapse = false;
        if (indxObj.chldIndx === null) {
            name = `inp_${indxObj.prgIndx}_${indxObj.subIndx}_${indxObj.spfIndx}_month${monthIndx}`;
        } else {
            name = `inp_${indxObj.prgIndx}_${indxObj.subIndx}_${indxObj.spfIndx}_${indxObj.chldIndx}_month${monthIndx}`;
            this.treeData[indxObj.prgIndx].vals[indxObj.subIndx].vals[indxObj.spfIndx].collapse = false;
        }
        await this.$nextTick();
        // eslint-disable-next-line
        // @ts-ignore
        if (this.$refs[name]) { this.$refs[name][0].select(); }
        if (!(this.selectedRow && this.selectedRow.prgIndx === indxObj.prgIndx && this.selectedRow.subIndx === indxObj.subIndx && this.selectedRow.spfIndx === indxObj.spfIndx && this.selectedRow.formIndx === indxObj.chldIndx)) {
            this.selectRow(indxObj.prgIndx, indxObj.subIndx, indxObj.spfIndx, indxObj.chldIndx);
        }
    }

    private getNextInputIndx(prgIndx: number, subIndx: number, spfIndx: number, chldIndx: number | null) {
        let newSpfIndx = spfIndx;
        let newSubIndx = subIndx;
        let newPrgIndx = prgIndx;
        let newChldIndx = null;
        if (this.treeData[prgIndx].vals[subIndx].vals.length-1 > spfIndx){
            newSpfIndx++;
        } else {
            if (chldIndx === null && this.treeData[prgIndx].vals[subIndx].vals[spfIndx].child_list && this.treeData[prgIndx].vals[subIndx].vals[spfIndx].child_list.length) {
                newChldIndx = 0;
            } else {
                if (this.treeData[prgIndx].vals.length - 1 > subIndx) {
                    newSubIndx++;
                    newSpfIndx = 0;
                } else {
                    if (this.treeData.length - 1 > prgIndx) {
                        newPrgIndx++;
                        newSubIndx = 0;
                        newSpfIndx = 0;
                    } else {
                        prgIndx = 0;
                        newSubIndx = 0;
                        newSpfIndx = 0;
                    }
                }
            }
        }
        return { prgIndx: newPrgIndx, subIndx: newSubIndx, spfIndx: newSpfIndx, chldIndx: newChldIndx };
    }
    // ---------

    private inputFocus(event: any) {
        event.target.select();
    }
    private deleteSpec(data: any) {
        const body = { data: data, type: 'obligation' }
        this.$bvModal.msgBoxConfirm(
            this.setText('delete_confirm'),
            {
                title: this.setText('confirmation'),
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.setText('yes'),
                cancelTitle: this.setText('canc'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    this.$emit('deleteSpec', body)
                }
            })
            .catch(error => {
                this.makeToast('danger', this.setText('errors.delete'), error.toString());
            });
    }
    private indexPrg = 0;
    private indexPpr = 0;
    private indexSpf = 0;
    private addTransfert(row: any | null, prgIndx: any, pprIndx: any, spfIndx: any){
        this.loadTransferts(row);
        this.indexPrg = prgIndx;
        this.indexPpr = pprIndx;
        this.indexSpf = spfIndx;
        this.itemsEl = row;
        this.showAddItemModal = true;
    }
    private noAbc(evt: any) {
        // Получаем вводимый символ
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);

        // Если введена запятая - заменяем на точку и предотвращаем стандартное поведение
        if (key === ',') {
            evt.preventDefault();

            const input = evt.target;
            const start = input.selectionStart;
            const end = input.selectionEnd;
            const currentValue = input.value;

            // Вставляем точку вместо запятой
            const newValue = currentValue.substring(0, start) + '.' + currentValue.substring(end);
            input.value = newValue;

            // Устанавливаем курсор после вставленной точки
            input.selectionStart = input.selectionEnd = start + 1;

            // Инициируем событие для обновления модели
            const inputEvent = new Event('input', { bubbles: true });
            input.dispatchEvent(inputEvent);

            // Валидируем получившееся значение
            const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
            if (!regex.test(newValue)) {
                // Если значение невалидно - откатываем
                input.value = currentValue;
                input.selectionStart = input.selectionEnd = start;
                return false;
            }

            return true;
        }

        // Стандартная валидация для остальных символов
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }
    private async loadSettingsTr() {
        const response = await fetch(`/api-py/get-settings`);
        this.settingsData = await response.json();
        for (const el of this.settingsData) {
            if (['transfers'].includes(el['code'].trim())) {
                this.showAddItemButton = el['value']
            }
        }
    }
    private async loadTransferts(el: any) {
        const response = await fetch(`/api/budget-execution-alteration/budget-transfer?region=${el.region}&year=${el.year}&abp=${el.abp}`);
        const filteredData = await response.json();
        this.transfertData = filteredData.filter((item: any) => {
            return item.prg === el.prg && (item.ppr ?? 0) === (el.ppr ?? 0);
        });

        let newTransfIndx = 0;
        for (const tr of this.transfertData) {
            tr['check'] = false;
            tr['locked'] = false;
            tr['index'] = newTransfIndx;
            for (const item of el?.child_list) {
                if (item['expense_code'] === tr['expense_code']) {
                    tr['check'] = true;
                    tr['locked'] = true;
                }
            }
            newTransfIndx++;
        }
        this.transfertData.sort((a, b) => (a.expense_code - b.expense_code > 0 ? 1 : -1));
    }
    private addedItems (items: any) {
        this.$emit('addItem', items);
    }
    private getLocalizedExpenseName(item: any) {
        const lang = this.$i18n.locale; // или из Vuex/i18n
        const fieldName = `expense_name_${lang}`;
        return item[fieldName] || item.expense_name_ru; // fallback
    }
    // Группа примечания для строки специфики (chldEl === null) либо проекта в её составе
    private getReasonGroup(spfEl: any, chldEl: any = null): IReasonGroup | null {
        const expenseCode = chldEl ? chldEl.expense_code : null;
        const key = reasonKey(spfEl.prg, spfEl.ppr, spfEl.spf, expenseCode, this.reasonPlanType);
        return this.reasonGroups[key] || null;
    }
    private editReason(spfEl: any, chldEl: any = null) {
        const expenseCode = chldEl ? chldEl.expense_code : null;
        const target: IReasonTarget = {
            planType: this.reasonPlanType,
            gr: spfEl.gr,
            prg: spfEl.prg,
            ppr: spfEl.ppr,
            spf: spfEl.spf,
            expenseCode: expenseCode,
            group: this.getReasonGroup(spfEl, chldEl)
        };
        this.$emit('editReason', target);
    }
    // Просмотр примечания, когда редактирование недоступно (статус/права) - модалка в режиме просмотра (EAK-808)
    private viewReason(spfEl: any, chldEl: any = null) {
        const group = this.getReasonGroup(spfEl, chldEl);
        if (group) { this.$emit('viewReason', group); }
    }
}
